import { render, staticRenderFns } from "./MtBasicModal.vue?vue&type=template&id=814d4b3a&"
import script from "./MtBasicModal.vue?vue&type=script&lang=js&"
export * from "./MtBasicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports